import {
  get_datiUserInfo
} from "@/api/api.user.js";
import storage from "../../services/storage";

const user = {
  namespaced: true,

  state: {
    user: '',
    roleId: '',
    menu: [],
    displayName: "",
    eMail: "",
    telefono: "",
    userId: null,
    nomeDipendente: "",
    codiceBadge: "",
    amministratore: false,
  },

  mutations: {
    SET_USER: (state, user) => {

      state.user = user.username
      state.roleId = user.roleId
      state.menu = user.menu
      state.displayName = user.displayName
      state.eMail = user.eMail
      state.telefono = user.telefono
      state.userId = user.userId
      state.nomeDipendente = user.nomeDipendente
      state.codiceBadge = user.codiceBadge
      state.amministratore = user.amministratore
    },

  },

  actions: {

    userInfo({
      commit,
      dispatch
    }) {

      return new Promise((resolve, reject) => {

        get_datiUserInfo().then(resp => {

          commit("SET_USER", resp.data)

          resolve(resp)

        }).catch(err => {
          reject(err);
          storage.logout();
        })
      })

    },


  },

  getters: {
    getRole: state => state.roleId,
    getTitolo: state => link => {
      let itemFind = state.menu.find(x => x.Link === link);
      if (itemFind)
        return itemFind.Text + '|' + itemFind.Img;

      return ""
    },
    getNome: state => {
      return state.user
    },
    getMail: state => {
      return state.eMail
    },
    getTelefono: state => {
      return state.telefono
    },
    getUserId: state => {
      return state.userId
    },
    getDisplayName: state => {
      return state.displayName
    },
    getMenu: state => {
      return state.menu
    },
    getNomeDipendente: state => {
      return state.nomeDipendente
    },
    getCodiceBadge: state => {
      return state.codiceBadge
    },
    getAmministratore: state => {
      return state.amministratore
    },
    // Utente massimo è abilitato a preconfermare ma non a confermare
    getQuasiAmministratore: state => {
      return state.userId == 1127
    },
  }
}


export default user